import useReveal from "../lib/useReveal";

/**
 * Reveal — fades + lifts its children once they enter the viewport.
 * Subtle (200ms). Use `delay` (ms) to stagger sibling reveals.
 */
export default function Reveal({ children, delay = 0, className = "", as: Tag = "div" }) {
  const { ref, visible } = useReveal();
  return (
    <Tag
      ref={ref}
      style={{ transitionDelay: `${delay}ms` }}
      className={`transition-all duration-200 ease-out will-change-transform ${
        visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-2"
      } ${className}`}
    >
      {children}
    </Tag>
  );
}
